enum GlowingBulbVariant {
  OnOff,
  Pairing,
  APPairing
}

export default GlowingBulbVariant;


// WEBPACK FOOTER //
// ./src/enums/GlowingBulbVariant.ts